import React from 'react'
import Link from './Link'
import styled from 'react-emotion'
import ProjectsContext from './ProjectsContext'
import Caption from './Caption'
import Image from './Image'
import { H2 } from './Style'

export default ({ currentProject }) => (
  <ProjectsContext.Consumer>
    {({ allProjects }) => (
      <Container>
        <H2>More projects</H2>

        <ProjectsList>
          {allProjects
            .filter(
              project => project.projectName !== currentProject.projectName
            )
            .map(project => (
              <Project key={project.clientName}>
                <Link
                  to={`/projects/${project.clientName.toLowerCase()}`}
                  noUnderline innerHighlight>
                  <Image
                    path={`projects/${project.clientName.toLowerCase()}/${project.clientName.toLowerCase()}-icon.jpg`}
                  />
                </Link>

                <Caption>
                  <Link
                    to={`/projects/${project.clientName.toLowerCase()}`}
                    white
                    className="smaller inner-link">
                    {project.projectName}
                  </Link>
                  {' '}
                  {project.technologies.map(tech => (
                    <span key={tech}>{tech}{' '}</span>
                  ))}
                </Caption>
              </Project>
            ))}
        </ProjectsList>
      </Container>
    )}
  </ProjectsContext.Consumer>
)

const Container = styled.div`
  margin: 80px 0 60px 0;
`

const ProjectsList = styled.div`
  display: flex;
  flex-flow: row wrap;
`

const Project = styled.div`
  width: calc(20% - 16px);
  margin-right: 20px;
  box-sizing: border-box;

  @media only screen and (max-width: 1023px) {
    width: calc(50% - 20px);
    margin-bottom: 20px;
  }

  &:last-child {
    margin-right: 0;
  }

  &:nth-child(2) {
    @media only screen and (max-width: 1023px) {
      margin-right: 0;
    }
  }
`
